import React,{useState, useEffect, useRef}  from 'react';
import {useHistory,useParams, useLocation} from 'react-router-dom'
import {Segment,Header,Container,  Form}  from 'semantic-ui-react'
import {SearchSelect,showDatum} from '@wollo-lib/wollo-react'
import MyTabulator,{dateFormatter, autoNumFormatter} from '@wollo-lib/wollo-tabulator'
import AddKunde from './AddKunde'
//import SearchSelect  from '../SearchSelect'



const ShowPaket=({db})=>
{
    
    const {PaketId}=useParams()
    const [paket,setPaket]=useState({Kunde:''})
    const [sisters, setSisters]=useState([])
    const history=useHistory()
    const [modalOpen,setModalOpen]=useState(false)


    const usersDB=db.users
    const paketeDB=db.pakete
    
    useEffect(()=>{

        const getPaket= async()=>
        {
            const myPaket= await paketeDB.get(PaketId)
            setPaket(myPaket)
        }
        if(PaketId)
        {
            getPaket()
        }
  
    },[PaketId])

    useEffect(()=>{
        const getPakete= async()=>
        {
            const mySisters= await paketeDB.where('Kunde').equals(paket.Kunde).toArray()
            setSisters(mySisters)
        }
        if( paket.Kunde)
            getPakete()
        else
            setSisters([])
    },[paket.Kunde])

    const handleChange=(e,{name,value})=>
    {
        if(value && name)
        {
            paketeDB.update(PaketId,{[name]:value})
            setPaket(p=>({...p,[name]:value}))
        }
    }

    function cellClick (cell) 
    {
        if(cell.getField()==='id')
        {
            history.push(`/show/paket/${cell.getValue()}`)
        }
    }
    

    

    const columns=[
   
        {formatter:autoNumFormatter, width:50, frozen:true}, //incrementing row number
        {formatter:(cell, formatterParams)=>('<i class="icon edit"></i>'), field:'id', width:50, hozAlign:"center"}, // edit 
        { title: 'Dienst', field: 'Dienst', width: 120,  headerFilter:"input"},
        { title: 'Datum', field: 'Datum', width: 120, formatter:dateFormatter},
        { title: 'Paketnummer', field: 'Paketnummer', width: 300,  headerFilter:"input"},
        { title: 'Absenderkennung', field:'AbsenderK', width: 400, headerFilter:"input"}
        
    ]
    return (
        <Container >
        {   ! modalOpen ?
            <Segment>
               <Header as="h2">{paket.Dienst} {showDatum(paket.Datum,'DD.MM.YYYY')} {paket.Paketnummer}</Header>
               <Header as="h4">Absenderkennung: {paket.AbsenderK}</Header>
               <Form>
                  <Form.Button color='green' icon='plus' content='neuer Kunde' onClick={(e)=>{ setModalOpen(true)}}/>
                <Form.Field
                        label='Kunde' 
                        value={paket.Kunde} 
                        name='Kunde' 
                        onChange={handleChange} 
                        placeholder={'Kundennnamen suchen'}
                        control={SearchSelect}
                        Value2TitleUrl={{
                                table: usersDB,
                                field: 'UID', 
                                map: el=>({
                                    key:el.UID,
                                    value: el.UID,
                                    title: `${el.Vorname} ${el.Nachname} ${el.PLZ} ${el.Ort}`
                                })
                        }}
                        SuggestDexie={{ 
                                        table: usersDB,
                                        field:'fulltext', 
                                        map: el=> ({
                                                        key:el.UID, 
                                                        title:`${el.Vorname} ${el.Nachname} ${el.PLZ} ${el.Ort}`, 
                                                        value: el.UID, 
                                                        typ:'Kunde'})}} 
                        api='back'
                        autoSelect

                    />
                </Form>
              
                <Form.Dropdown
                        label='Paketdienst'
                        value={paket.Dienst}
                        selection
                        options={
                            ['DHL','DHL-Express','Hermes','DPD','GLS','UPS','FEDEX']. map(el=>({key:el,text:el,value:el}))
                        }
                        placeholder = "Paketdienst wählen"
                        onChange={handleChange}
                        name='Dienst'

                />
                
                { !sisters.length ? '' :
                    <>
                        <Header> weitere Pakete dieses Kunden</Header>
                        <MyTabulator
                            index='id'
                            columns={columns}
                            headerFilterPlaceholder="Spalte filtern"
                            data={sisters}
                            onClick={cellClick}
                
                        />
                    </>
                }
            </Segment>
            :
            <AddKunde
                    open={modalOpen}
                    setOpen={setModalOpen}
                    db={db}

                    baseHandleChange={handleChange}

            />
        }
        </Container>
    )

}
export default ShowPaket
